import React from 'react';
import PropTypes from 'prop-types';

const DigiLocker = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.55859 11.4198V15.0588C3.55859 15.246 3.63296 15.4256 3.76534 15.558C3.89772 15.6903 4.07726 15.7647 4.26448 15.7647H13.7939C13.9811 15.7647 14.1606 15.6903 14.293 15.558C14.4254 15.4256 14.4998 15.246 14.4998 15.0588V5.88235H11.3233C11.1361 5.88235 10.9565 5.80798 10.8242 5.6756C10.6918 5.54323 10.6174 5.36368 10.6174 5.17647V2H4.26448C4.07726 2 3.89772 2.07437 3.76534 2.20675C3.63296 2.33913 3.55859 2.51867 3.55859 2.70588V7.69467"
      stroke={fill || '#6B6C7B'}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6177 2L14.5 5.88235"
      stroke={fill || '#6B6C7B'}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5224 8.15007C9.50743 8.15007 9.49296 8.15194 9.47811 8.15229C9.38824 7.6285 9.13682 7.14593 8.75904 6.77214C8.38127 6.39835 7.89605 6.15207 7.37133 6.06777C6.84662 5.98348 6.30868 6.0654 5.83283 6.30205C5.35699 6.5387 4.96707 6.91825 4.71767 7.38754C4.70232 7.38719 4.68742 7.38521 4.672 7.38521C4.09595 7.38521 3.54349 7.61404 3.13616 8.02137C2.72884 8.4287 2.5 8.98116 2.5 9.55721C2.5 10.1333 2.72884 10.6857 3.13616 11.093C3.54349 11.5004 4.09595 11.7292 4.672 11.7292H9.5224C9.99702 11.7292 10.4522 11.5407 10.7878 11.2051C11.1234 10.8694 11.312 10.4143 11.312 9.93964C11.312 9.46502 11.1234 9.00983 10.7878 8.67422C10.4522 8.33861 9.99702 8.15007 9.5224 8.15007Z"
      stroke={fill || '#6B6C7B'}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

DigiLocker.propTypes = {
  fill: PropTypes.string,
};

export default DigiLocker;
